export interface PointLightExt {

}